import { useTranslation } from 'react-i18next'
import { useSetRecoilState } from 'recoil';
import { Settings } from 'luxon';
import { AuthModel, AuthState } from 'models/AuthModel';
import auth from 'recoil/atoms/auth';
import Api from 'utils/api';


const useAuth = () => {
    const {i18n} = useTranslation()
    const setUser = useSetRecoilState(auth);

    const setAsGuest = () => setUser({
        state: AuthState.Guest,
    } as AuthModel);

    const authorize = (token: string) => {
        localStorage.setItem('token', token);
        Api.authorize(token);
        Api.auth.user().then(res => {
            const user = res.data.data
            setUser({
                ...user,
                permissions: new Set(user.permissions),
                state: AuthState.User,
            });

            i18n.changeLanguage(user.settings.locale);
            Settings.defaultLocale = user.settings.locale;
        });
    };

    const login = (email: string, password: string, remember: boolean) => {
        return Api.auth.login(email, password, remember)
            .then(res => authorize(res.data.token));
    };

    const logout = () => {
        Api.auth.logout()
            .then(() => {
                localStorage.removeItem('token');
                window.location.reload();
            })
    };

    const rename = (lastName: string, firstName: string, phone: string) => {
        return Api.auth.rename({lastName, firstName, phone})
            .then(() => setUser(old => ({
                ...old,
                lastName,
                firstName,
                phone,
            })))
    };

    const setLocale = (locale: string) => Api.auth
        .setSettings({locale})
        .then(() => setUser(old => ({
            ...old,
            settings: {
                ...old.settings,
                locale,
            },
        })))
        .then(() => i18n.changeLanguage(locale))
        .then(() => Settings.defaultLocale = locale)

    return {
        setAsGuest,
        login,
        logout,
        register: Api.auth.register,
        requestInvite: Api.auth.requestInvite,
        authorize,
        forgotPassword: Api.auth.forgotPassword,
        resetPassword: Api.auth.resetPassword,
        finishInvite: Api.auth.finishInvite,
        resendEmailVerification: Api.auth.resendEmailVerification,
        rename,
        updatePassword: Api.auth.updatePassword,
        setLocale,
    };
};

export default useAuth;
